import { DoneAll, Download, DownloadDone, NavigateBeforeOutlined, NavigateNextOutlined, PhotoCamera } from "@mui/icons-material";
import { Avatar, Box, Button, Card, CardActions, CardContent, CircularProgress, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AdayIdxRootservice from "../../../service/Ebasvuru/AdayDomain/AdayIdxRootService";
import { parseAndFormatDate } from "../../../util/DateUtil";
import useGlobal from "../../../util/Global";
import ApiUrl from "../../../service/ApiUrl";
import { imageToByteArray } from "../../../util/Util";
import useMessage from "../../../util/useMessagev2";
import { useShareContext } from "./BasvuruContext";
import { PhotoUploader } from "../../../components/uploaders/PhotoUploader";
import { FileUploader } from "../../../components/uploaders/FileUploader";

const BasvurProfile = ({ basvuruFormuId, moveBlokler, isFinish }) => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [fileUpload, setFileUpload] = useState(null);
    const [aday, setAday] = useState(null);
    const { t } = useGlobal();
    const message = useMessage();
    const [fileName, setFileName] = useState('');
    const [loadFile, setLoadFile] = useState(false);
    const [loadImage, setLoadImage] = useState(false);

    const { setbasvuruFormBlokId } = useShareContext();

    const { user } = useSelector(user => user.auth);

    const handleImageChange = async (file) => {

        setLoadImage(true);
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            try {

                const byteArray = await imageToByteArray(file);

                AdayIdxRootservice.FilePost({
                    url: ApiUrl.publicEndpoint.FotoYukle,
                    paramters: {
                        _adayId: user.userId,
                        _byteArray: Array.from(byteArray)
                    }
                }).then((res) => {
                    if (res && res.isSuccess) {
                        message.success(t('message.uploadSuccess'))
                        setFileUpload(imageUrl);
                        setLoadImage(false);
                    }
                });
            } catch (error) {
                message.error(t('message.uploadSuccessWithError'));
            }

        }
    };

    const handelCVChange = async (file) => {
        try {

            setLoadFile(true);

            if (file) {
                const byteArray = await imageToByteArray(file);

                AdayIdxRootservice.FilePost({
                    url: ApiUrl.publicEndpoint.UploadCv,
                    paramters: {
                        _adayId: user.userId,
                        _byteArray: Array.from(byteArray)
                    }
                }).then((res) => {

                    if (res && res.isSuccess) {
                        message.success(t('message.uploadSuccess'))
                        setFileUpload(file);
                        setLoadFile(false);
                    } else {
                        message.error(t('message.uploadSuccessWithError'));
                    }
                });
            }
        } catch (error) {
            message.error(t(error));
            setLoadFile(false);
        }

    }

    useEffect(() => {
        let isMounted = true;

        setbasvuruFormBlokId(null);

        AdayIdxRootservice.fullGet({
            filter: {
                id: user.userId
            }
        })
            .then((res) => {
                if (isMounted && res.isSuccess && res?.resultObject) {
                    setAday(res?.resultObject[0]);

                }
            });
        return () => {
            isMounted = false; // Cleanup: Prevent state update after unmount
        };
    }, [user, fileUpload]);

    useEffect(() => {

        if (aday && aday?.fotoUrl) {
            setSelectedImage(aday.storage + aday?.fotoUrl);
        }

        if (aday && aday?.cvUrl) {
            setFileName(aday.storage + aday?.cvUrl);
        }
    }, [aday])

    return (
        <Card sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <CardActions sx={{ width: "98%", }}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Button
                            sx={{ minWidth: 100 }}
                            startIcon={<NavigateBeforeOutlined />}
                            color="primary"
                            variant="contained"
                            disabled
                            onClick={() => moveBlokler(false)}
                        >
                            {t("action.previous")}
                        </Button>
                    </Grid>
                    <Grid item>

                    </Grid>
                    <Grid item>
                        {!isFinish &&
                            (<Button
                                sx={{ minWidth: 100 }}
                                endIcon={<NavigateNextOutlined />}
                                color="primary"
                                variant="contained"
                                onClick={() => moveBlokler(true)}
                            >
                                {t("action.next")}
                            </Button>)
                        }
                    </Grid>
                </Grid>
            </CardActions>
            <CardContent>
                <Grid container spacing={2} sx={{ width: '100%', mt: 4 }}>
                    <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <PhotoUploader
                            initialPreview={selectedImage}
                            onChange={handleImageChange}
                            isLoading={loadImage} />

                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }} >
                        <FileUploader
                            onChange={handelCVChange}
                            initialPreview={fileName}
                            maxSizeMb={10}
                            isLoading={loadFile}
                            labelAddKey='col.addCV'
                            labelUpdateKey='col.changeCV'
                            beforeAddMessage='col.cvAddSistem'
                            afterAddMessage='col.cvChangeSistem'
                        />
                    </Grid>
                </Grid>

                {/* Form Fields */}
                <TextField InputLabelProps={{ shrink: true }} fullWidth label={t('col.fullName')} value={aday?.adSoyad} sx={{ mt: 4 }} disabled />
                <TextField InputLabelProps={{ shrink: true }} fullWidth label={t('col.cepTel')} value={aday?.cepTel} sx={{ mt: 4 }} disabled />
                <TextField InputLabelProps={{ shrink: true }} fullWidth label={t('col.emailAdres')} value={aday?.email} sx={{ mt: 4 }} disabled />
                <TextField InputLabelProps={{ shrink: true }} fullWidth label={t('col.tCKimlikNo')} value={aday?.tcKimlikNo} sx={{ mt: 4 }} disabled />
                <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    label={t('col.birthdate')}
                    value={parseAndFormatDate(aday?.dogumTarihi)}
                    sx={{ mt: 4 }}
                    disabled
                />

            </CardContent>
        </Card >
    );
}

export default BasvurProfile;